import { createTheme, type MantineColorsTuple } from "@mantine/core";

// Loosely matches fireslot-web: dark navy surfaces, purple accent #886cff. System fonts only (no CSP exceptions).
const violet: MantineColorsTuple = [
  "#f1edff",
  "#ddd5ff",
  "#b9a8ff",
  "#9a84ff",
  "#886cff",
  "#7a5cf5",
  "#6a4de0",
  "#5a3fc4",
  "#4b34a3",
  "#3d2b85",
];

// Mantine "dark" scale: [0] lightest text … [7] body background … [9] deepest.
const navy: MantineColorsTuple = [
  "#c9d1e6",
  "#a7b1cc",
  "#7f8bab",
  "#5b6788",
  "#3a4565",
  "#283252",
  "#1c2541",
  "#131a30",
  "#0e1426",
  "#090d1a",
];

export const theme = createTheme({
  primaryColor: "violet",
  primaryShade: { light: 6, dark: 4 },
  colors: { violet, dark: navy },
  fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
  defaultRadius: "md",
  cursorType: "pointer",
  components: {
    Modal: { defaultProps: { overlayProps: { backgroundOpacity: 0.6, blur: 2 } } },
    Table: { defaultProps: { striped: false } },
  },
});
